import { InternalFetchMe, Logout } from 'src/constants/actionTypes'
import type { Action } from 'src/utils/reduxUtils'
import type { InternalAuthState } from './types'

const getInitialState = (): InternalAuthState => {
  return {
    identity: null,
    isLoading: false,
    error: null,
  }
}

export const internalAuthReducer = (
  state: InternalAuthState = getInitialState(),
  action: Action<any>,
): InternalAuthState => {
  switch (action.type) {
    case InternalFetchMe.type.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case InternalFetchMe.type.SUCCESS:
      return {
        ...state,
        isLoading: false,
        identity: action.payload,
        error: null,
      }
    case InternalFetchMe.type.FAILED:
      return {
        ...state,
        isLoading: false,
        identity: null,
        error: action.payload,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
